import { createApi } from '@reduxjs/toolkit/query/react';
import { ResponseDto } from 'types';
import {
  SystemConfigAIAgentDto,
  SystemConfigDto,
  UpdateSystemConfigAIAgentDto,
  UpdateSystemConfigDto
} from 'types/dto/system-configs';
import axiosBaseQuery from 'utils/base-api';

export const systemConfigsApi = createApi({
  reducerPath: 'systemConfigsApi',
  tagTypes: ['system_configs', 'system_configs_ai_agent'],
  baseQuery: axiosBaseQuery,
  endpoints: (builder) => ({
    //user-profile
    getSystemConfigs: builder.query<ResponseDto<SystemConfigDto>, void>({
      query: () => ({
        url: '/system_configs',
        method: 'get'
      }),
      providesTags: [{ type: 'system_configs' }]
    }),

    updateSystemConfig: builder.mutation<ResponseDto<null>, UpdateSystemConfigDto>({
      query: (updateData) => ({
        url: `/system_configs`,
        method: 'patch',
        data: updateData
      }),
      invalidatesTags: [{ type: 'system_configs' }]
    }),

    getSystemConfigsAIAgent: builder.query<ResponseDto<SystemConfigAIAgentDto>, void>({
      query: () => ({
        url: '/system_configs/ai-agent',
        method: 'get'
      }),
      providesTags: [{ type: 'system_configs_ai_agent' }]
    }),

    updateSystemConfigAIAgent: builder.mutation<ResponseDto<SystemConfigAIAgentDto>, UpdateSystemConfigAIAgentDto>({
      query: (updateData) => ({
        url: `/system_configs/ai-agent`,
        method: 'patch',
        data: updateData
      }),
      invalidatesTags: [{ type: 'system_configs_ai_agent' }]
    })
  })
});

export const {
  useGetSystemConfigsQuery,
  useUpdateSystemConfigMutation,
  useGetSystemConfigsAIAgentQuery,
  useUpdateSystemConfigAIAgentMutation
} = systemConfigsApi;
